/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link, useLocation} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

// Customer-service WhatsApp, the same number used in-app (onboarding wizard, tutorial,
// sidebar, support widget). 0722210190 → international: drop the 0, prepend 972.
const SUPPORT_WA_LINK = `https://wa.me/972722210190?text=${encodeURIComponent(
  'שלום, אני צריך/ה עזרה בהתחברות או בהרשמה 🙏'
)}`

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, []);

  const location = useLocation();

  const isRegistration = location.pathname === '/auth/registration' || location.pathname === '/auth/registration-single-profile';

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid min-h-100' style={{direction: 'rtl', minHeight: '100vh'}}>
      {/* begin::Body */}
      <div
        className='d-flex flex-column justify-content-center flex-lg-row-fluid w-lg-50 p-5 p-sm-8 p-lg-10 order-2 order-lg-1 bgi-size-cover bgi-position-center flex-grow-1'
        style={{
          backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-bg.png')})`,
          minHeight: '100vh',
        }}
      >
        {/* begin::Mobile Logo */}
        <div className='d-flex d-lg-none justify-content-center mb-8'>
          <img
            className='w-150px w-sm-200px'
            src={toAbsoluteUrl('/media/logos/d-code-logo-light.svg')}
            alt=''
          />
        </div>
        {/* end::Mobile Logo */}

        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div
            className={`w-100 ${isRegistration ? '' : 'w-sm-400px w-lg-500px'} p-6 p-sm-8 p-lg-10 bg-body rounded-3 shadow-sm`}
          >
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}
      </div>
      {/* end::Body */}

      {/* begin::Aside - hidden on mobile */}
      <div
        className={`d-none d-lg-flex flex-lg-row-fluid ${isRegistration ? '' : 'w-lg-50'} bgi-size-cover bgi-position-center order-1 order-lg-2`}
        style={{backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-bg.png')})`}}
      >
        {/* begin::Content */}
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
          {/* begin::Image */}
          <img
            className='mx-auto w-275px w-xl-400px mb-10 mb-lg-20'
            src={toAbsoluteUrl('/media/logos/d-code-logo-light.svg')}
            alt=''
          />
          {/* end::Image */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}

      {/* Customer service on WhatsApp. Someone who can't get past login or registration
          has no account, so the in-app support widget and the sidebar link are both out
          of reach — this is the only channel they have. Fixed to the corner so it's on
          every auth screen without each form having to carry it.
          No username to prefill: they aren't signed in yet, by definition. */}
      <a
        href={SUPPORT_WA_LINK}
        target='_blank'
        rel='noreferrer'
        title='תמיכה בוואטסאפ'
        style={{
          position: 'fixed', bottom: 20, left: 20, zIndex: 1050,
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '10px 16px', borderRadius: 999,
          background: 'linear-gradient(135deg, #25d366 0%, #1fb855 100%)',
          color: '#fff', fontWeight: 700, fontSize: 14, textDecoration: 'none',
          boxShadow: '0 6px 20px rgba(37, 211, 102, 0.35)',
        }}
      >
        <i className='bi bi-whatsapp' style={{color: '#fff', fontSize: 18}} />
        <span>צריכים עזרה?</span>
      </a>
    </div>
  )
}

export {AuthLayout}
